/**
 * Resource Tags API Client
 */

import { get, post, patch, del } from '@/lib/api-client'
import type {
  ResourceTagListResponse,
  ResourceTagDetail,
  ResourceTagRecord,
  ResourceTagQueryParams,
  CreateResourceTagRequest,
  UpdateResourceTagRequest,
  ResourceTagRecordInput,
  UpdateResourceTagRecordRequest,
  BulkDeleteRecordsRequest,
} from '@/types/resource-tag'

export async function fetchResourceTags(
  params: ResourceTagQueryParams = {}
): Promise<ResourceTagListResponse> {
  const queryParams = new URLSearchParams()

  if (params.page !== undefined) queryParams.set('page', String(params.page))
  if (params.pageSize !== undefined) queryParams.set('pageSize', String(params.pageSize))
  if (params.search) queryParams.set('search', params.search)

  const qs = queryParams.toString()
  return get<ResourceTagListResponse>(`/resource-tags${qs ? `?${qs}` : ''}`)
}

export async function fetchResourceTag(id: string): Promise<ResourceTagDetail> {
  return get<ResourceTagDetail>(`/resource-tags/${id}`)
}

export async function createResourceTag(
  data: CreateResourceTagRequest
): Promise<ResourceTagDetail> {
  return post<ResourceTagDetail>('/resource-tags', data)
}

export async function updateResourceTag(
  id: string,
  data: UpdateResourceTagRequest
): Promise<ResourceTagDetail> {
  return patch<ResourceTagDetail>(`/resource-tags/${id}`, data)
}

export async function deleteResourceTag(id: string): Promise<{ deleted: boolean }> {
  return del<{ deleted: boolean }>(`/resource-tags/${id}`)
}

export async function addResourceTagRecord(
  tagId: string,
  data: ResourceTagRecordInput
): Promise<ResourceTagRecord> {
  return post<ResourceTagRecord>(`/resource-tags/${tagId}/records`, data)
}

export async function updateResourceTagRecord(
  tagId: string,
  recordId: string,
  data: UpdateResourceTagRecordRequest
): Promise<ResourceTagRecord> {
  return patch<ResourceTagRecord>(`/resource-tags/${tagId}/records/${recordId}`, data)
}

export async function deleteResourceTagRecord(
  tagId: string,
  recordId: string
): Promise<{ deleted: boolean }> {
  return del<{ deleted: boolean }>(`/resource-tags/${tagId}/records/${recordId}`)
}

export async function bulkDeleteResourceTagRecords(
  tagId: string,
  data: BulkDeleteRecordsRequest
): Promise<{ deleted: number }> {
  return post<{ deleted: number }>(`/resource-tags/${tagId}/records/bulk-delete`, data)
}
